import { useState } from 'react';

const Menu = ({ title }) => 
{
  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menuName) =>
  {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  // Esta función se asegura de cerrar el menú antes de abrir el enlace
  const handleLinkClick = () =>
  {
    setOpenMenu(null);
    // El href y target hacen el resto
  };

  return (
    <div className="bg-gray-800 text-white flex justify-between items-center px-8 py-2 z-[3000] relative h-[60px]">
      {/* Créditos - Enlaces externos */}
      <div className="relative">
        <button
          className="hover:bg-gray-600 px-3 py-1 rounded bg-gray-700"
          onClick={() => toggleMenu('creditos')}
        >
          Créditos
        </button>

        {/* Menú desplegable */}
        {openMenu === 'creditos' && (
          <div className="absolute left-0 mt-2 bg-white text-black rounded shadow w-[300px] z-[9999]">
            <a
              href="https://www.linkedin.com/in/entornoceo/"
              target="_blank"
              rel="noopener noreferrer"
              className="block font-bold text-black px-4 py-2 hover:bg-gray-100 w-full text-left cursor-pointer"
              onClick={handleLinkClick}
            >
              Creado por: Ing. Javier Hernández
            </a>
          </div>
        )}
      </div>

      {/* Título del menú */}
      <div>
        <span className="font-bold uppercase">{title}</span>
      </div>
    </div>
  );
};

export default Menu;